import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptPagoMovilAccounts} from "./pagoMovilAccounts.adapter";
import type {
  CreatePagoMovilAccountPayload,
  PagoMovilAccount,
  PagoMovilAccountsApiResponse,
  UpdatePagoMovilAccountPayload,
} from "./pagoMovilAccounts.types";

export const getPagoMovilAccountsService = async (): Promise<PagoMovilAccount[]> => {
  const response = await httpRequest<PagoMovilAccountsApiResponse>({
    method: "GET",
    url: "/user/pago-movil-accounts",
    baseUrl: config.walletApiUrl,
  });
  return adaptPagoMovilAccounts(response);
};

export const createPagoMovilAccountService = async (payload: CreatePagoMovilAccountPayload): Promise<unknown> => {
  return httpRequest<unknown, CreatePagoMovilAccountPayload>({
    method: "POST",
    url: "/user/pago-movil-account",
    baseUrl: config.walletApiUrl,
    body: payload,
  });
};

export const updatePagoMovilAccountService = async (payload: UpdatePagoMovilAccountPayload): Promise<unknown> => {
  return httpRequest<unknown, UpdatePagoMovilAccountPayload>({
    method: "PATCH",
    url: "/user/pago-movil-account",
    baseUrl: config.walletApiUrl,
    body: payload,
  });
};

export const deletePagoMovilAccountService = async (id: string): Promise<unknown> => {
  return httpRequest<unknown>({
    method: "DELETE",
    url: `/user/pago-movil-account/${encodeURIComponent(id)}`,
    baseUrl: config.walletApiUrl,
  });
};
